// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__rRM+-","layout-body":"Layout_layout-body__EBxyl"};